<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />

    <Loading :open="loading" />

    <DataTable
      v-show="mostrarSkeleton == false"
      :tableTitle="'Dispensa para paciente'"
      :tableHeader="headers"
      :tableRows="lista"
      :totalItens="total"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
      :newRowmodalButtonText="'Nova Dispensa'"
      :isViewEdit="true"
      :isEdit="false"
      :isFinish="false"
      :isDel="false"
      :isPrint="true"
      :isDevolucao="true"
      v-on:datatable-newrow="modalDeInserir"
      v-on:datatable-viewrow="modalVisualizar"
      v-on:datatable-devolucao="modalDeletar"
      v-on:datatable-print="modalNotas"
    ></DataTable>

    <SkeletonTable v-show="mostrarSkeleton == true" :showSkeletonTable="mostrarSkeleton"></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="acoesModal"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
        </v-col>
      </v-row>

      <v-form v-model="tudoValido">
        <v-text-field
          prepend-icon="mdi-account-search"
          @click:prepend="buscarPessoa"
          v-model="modalCustomSize.dadosModal.descricaoCpf"
          name="cpf"
          label="Buscar CPF para iniciar a dispensa"
          v-mask="['###.###.###-##']"
          :rules="[rules.requerido]"
          autocomplete="off"
          v-if="!modalCustomSize.isView"
        ></v-text-field>

        <v-expand-transition>
          <v-expansion-panels v-if="liberarFormulario && !modalCustomSize.isView" v-model="panelDispensa" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header><b>Paciente</b></v-expansion-panel-header>

              <v-expansion-panel-content eager>
                <v-row v-if="modalCustomSize.dadosModal.descricaoCpf.length == 14" dense>
                  <v-col cols="6">
                    <v-text-field v-model="modalCustomSize.dadosModal.descricaoNome" label="Nome do paciente" autocomplete="off" :rules="[rules.requerido]"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="modalCustomSize.dadosModal.dataNascimento" label="Data de nascimento" autocomplete="off" v-mask="['##/##/####']" :rules="[rules.requerido]"></v-text-field>
                  </v-col>
                </v-row>

                <v-expansion-panels v-model="panelDadosPaciente" multiple>
                  <!-- #region INFORMAÇÕES DO RESPONSÁVEL -->
                  <v-expand-transition>
                    <v-expansion-panel v-if="liberarResponsavel && modalCustomSize.dadosModal.indicadorCartao == 0">
                      <v-expansion-panel-header><b>Responsável</b></v-expansion-panel-header>

                      <v-expansion-panel-content eager>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field v-model="modalCustomSize.dadosModal.descricaoNomeResponsavel" name="descricaoNomeResponsavel" label="Nome completo do Responsável" autocomplete="off" :rules="[rules.requerido]"></v-text-field>
                          </v-col>

                          <v-col cols="6">
                            <v-text-field v-model="modalCustomSize.dadosModal.descricaoCpfResponsavel" name="descricaoCpfResponsavel" label="CPF do Responsável" autocomplete="off" v-mask="['###.###.###-##']" :rules="[rules.requerido]"></v-text-field>
                          </v-col>

                          <v-col cols="6">
                            <v-text-field v-model="modalCustomSize.dadosModal.descricaoDataNascimentoResponsavelFormatado" name="descricaoDataNascimentoResponsavel" v-mask="['##/##/####']" label="Data Nascimento do Responsável" autocomplete="off" :rules="[rules.requerido]"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expand-transition>
                  <!-- #endregion -->

                  <!-- #region CÓDIGO FORMULARIO COMENTADO -->
                  <!-- 
                  #region INFORMAÇÕES DO MUNÍCIPE
                  <v-expansion-panel v-if="modalCustomSize.dadosModal.indicadorCartao == 0">
                    <v-expansion-panel-header><b>Munícipe</b></v-expansion-panel-header>

                    <v-expansion-panel-content eager>
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoNomeSocial" name="descricaoNomeSocial" label="Nome Social" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-autocomplete label="Raça" v-model="modalCustomSize.dadosModal.descricaoRaca" :items="listaDeRaca" name="descricaoRacaCor" :rules="[rules.requeridoCampo]"></v-autocomplete>
                        </v-col>

                        <v-col cols="6">
                          <v-autocomplete label="Sexo" v-model="modalCustomSize.dadosModal.descricaoSexo" :items="listaDeSexo" name="descricaoSexo" :rules="[rules.requeridoCampo]"></v-autocomplete>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.nomeMae" name="nomeMae" label="Nome da Mãe" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.nomePai" name="nomePai" label="Nome do Pai" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoPaisNascimento" name="descricaoPaisNascimento" label="País de Nascimento" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoNacionalidade" name="descricaoNacionalidade" label="Nacionalidade" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  #endregion

                  #region INFORMAÇÕES DE ENDEREÇO
                  <v-expansion-panel v-if="modalCustomSize.dadosModal.indicadorCartao == 0">
                    <v-expansion-panel-header><b>Endereço</b></v-expansion-panel-header>

                    <v-expansion-panel-content eager>
                      <v-row dense>
                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoCep" name="descricaoCep" label="CEP" autocomplete="off" v-mask="'#####-###'" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-autocomplete v-model="modalCustomSize.dadosModal.descricaoTipoLogradouro" label="Tipo de Logradouro" :items="listaDeTipoLogradouro" name="descricaoTipoLogradouro" :rules="[rules.requeridoCampo]"></v-autocomplete>
                        </v-col>

                        <v-col cols="10">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoEndereco" name="descricaoEndereco" label="Endereço" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="2">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoNumero" name="descricaoNumero" label="Número" autocomplete="off" :rules="[rules.requeridoCampo]" v-mask="'######'"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoComplemento" name="descricaoComplemento" label="Complemento" autocomplete="off"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoBairro" name="descricaoBairro" label="Bairro" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="4">
                          <v-autocomplete v-model="modalCustomSize.dadosModal.descricaoMunicipio" label="Município" :items="listaDeMunicipio" name="descricaoMunicipio" :rules="[rules.requeridoCampo]"></v-autocomplete>
                        </v-col>

                        <v-col cols="4">
                          <v-autocomplete v-model="modalCustomSize.dadosModal.descricaoEstado" label="Estado" :items="listaDeEstado" name="descricaoEstado" :rules="[rules.requeridoCampo]"></v-autocomplete>
                        </v-col>

                        <v-col cols="4">
                          <v-autocomplete v-model="modalCustomSize.dadosModal.descricaoPais" label="País" :items="listaDePais" name="descricaoPais" :rules="[rules.requeridoCampo]"></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  #endregion

                  #region INFORMAÇÕES DE CONTATO
                  <v-expansion-panel v-if="modalCustomSize.dadosModal.indicadorCartao == 0">
                    <v-expansion-panel-header><b>Contato</b></v-expansion-panel-header>

                    <v-expansion-panel-content eager>
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoEmail" name="descricaoEmail" label="E-mail" autocomplete="off"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoTelefone" name="descricaoTelefone" label="Telefone" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></v-text-field>
                        </v-col>

                        <v-col cols="6">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoCelular" name="descricarCelular" label="Celular" autocomplete="off" v-mask="['(##) ####-####', '(##) #####-####']"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  #endregion

                  #region INFORMAÇÕES DE DOCUMENTAÇÃO
                  <v-expansion-panel v-if="modalCustomSize.dadosModal.indicadorCartao == 0">
                    <v-expansion-panel-header><b>Documentação</b></v-expansion-panel-header>

                    <v-expansion-panel-content eager>
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoCns" name="descricaoCns" label="CNS - Cartão do SUS" autocomplete="off" :rules="[rules.requeridoCampo]"></v-text-field>
                        </v-col>

                        <v-col cols="4">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoRg" name="descricaoRg" label="RG" autocomplete="off"></v-text-field>
                        </v-col>

                        <v-col cols="4">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoDataExpedicao" name="descricaoDataExpedicao" label="Data de Expedição (RG)" autocomplete="off" v-mask="['##/##/####']"></v-text-field>
                        </v-col>

                        <v-col cols="4">
                          <v-text-field v-model="modalCustomSize.dadosModal.descricaoOrgaoEmissor" name="descricaoOrgaoEmissor" label="Orgão Emissor (RG)" autocomplete="off"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  #endregion 
                  -->
                  <!-- #endregion -->
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expand-transition>
              <v-expansion-panel v-if="dispensasDoPaciente.length > 0">
                <v-expansion-panel-header><b>Últimas Dispensas</b></v-expansion-panel-header>

                <v-expansion-panel-content eager>
                  <v-row dense>
                    <v-col cols="12">
                      <v-list>
                        <v-list-group v-for="(dispensa, i) in dispensasDoPaciente" :key="i" no-action>
                          <template v-slot:activator>
                            <v-list-item-content>
                              <v-list-item-title>{{ "Dispensa da Unidade: " + dispensa.endereco.nomeEndereco + " - " + formatarData(dispensa.dispensaPaciente.dataDispensa) }}</v-list-item-title>
                            </v-list-item-content>
                          </template>

                          <v-list-item-content>
                            <v-row cols="12" align="center">
                              <v-col cols="12" class="px-4">
                                <DataTable :tableTitle="'Produtos dispensados para o paciente: ' + modalCustomSize.dadosModal.descricaoNomeView" :tableHeader="headersItensDispensados" :tableRows="dispensa.listaDeItens"></DataTable>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-group>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expand-transition>

            <v-expansion-panel>
              <v-expansion-panel-header><b>Dispensa de Produtos</b></v-expansion-panel-header>

              <v-expansion-panel-content eager>
                <v-row dense>
                  <v-col cols="12" class="pb-0">
                    <v-col class="text-caption pb-0 pl-0">Tipo de Dispensa:</v-col>
                  </v-col>

                  <v-col cols="12" class="pt-0">
                    <v-radio-group v-model="modalCustomSize.dadosModal.indicadorTipoDispensa" row>
                      <v-radio label="UTI" value="1"></v-radio>
                      <v-radio label="Enfermaria" value="2"></v-radio>
                      <v-radio label="Centro Cirúrgico" value="3"></v-radio>
                      <v-radio label="SADT" value="4"></v-radio>
                      <v-radio label="Mandato Judicial" value="5"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="6">
                    <v-autocomplete label="Buscar por sub estoque" :items="listaDeSubestoque" v-model="subestoqueSelecionado" clearable></v-autocomplete>
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete label="Buscar por família" :items="listaDeFamilias" v-model="familiaSelecionada" clearable></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete label="Lista de Produtos" :items="listaDeMateriais" v-model="itemSelecionado"></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-data-table :headers="headersItens" :search="searchItemDispensa" :items="modalCustomSize.dadosModal.listaDeItensEnviados" disable-sort>
                      <template v-slot:top>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </template>

                      <template v-slot:[`item.validade`]="{ item }">
                        <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
                      </template>

                      <template v-slot:[`item.item.validade`]="{ item }">
                        <v-chip :color="corValidade(item.item.validade)" dark>{{ item.item.validade }}</v-chip>
                      </template>

                      <template v-if="!modalCustomSize.isView" v-slot:[`item.quantidade`]="props">
                        <v-text-field style="max-width:250px" v-model="props.item.quantidade" :rules="[rules.requerido]" label="Quantidade para Dispensar" single-line @keypress="(event) => filter(event)"></v-text-field>
                      </template>

                      <template v-if="!modalCustomSize.isView" v-slot:[`item.actions`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small @click="removerItemDaLista(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
                          </template>
                          <span>Excluir</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expand-transition>

        <v-col cols="12" v-if="modalCustomSize.isView">
          <DataTable
            :tableTitle="'Produtos Dispensados para o paciente: ' + modalCustomSize.dadosModal.descricaoNomeView"
            :tableHeader="headersItensDispensados"
            :tableRows="modalCustomSize.dadosModal.listaDeItensEnviados"
            :isDevolucaoProduto="true"
            v-on:datatable-devolucao-produto="modalDeletarItem"
          ></DataTable>
        </v-col>
      </v-form>
    </ModalCustomSize>

    <DeleteItemModal :showModalDelete="modalDeleteItem.abrir" :textModalDelete="modalDeleteItem.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDeleteItem.abrir = false" v-on:on-response-modal-delete="deletarItem"></DeleteItemModal>

    <DeleteItemModal :showModalDelete="modalDelete.abrir" :textModalDelete="modalDelete.texto" :buttomTextModalDelete="'Devolver'" v-on:close-modal="modalDelete.abrir = false" v-on:on-response-modal-delete="deletar"></DeleteItemModal>

    <TipoImpressao
      v-if="$store.state.numeroEndereco != 127 || $store.state.numeroEndereco != '127'"
      :showModal="modalImpressao.modalAberta"
      v-on:close-modal="modalImpressao.modalAberta = false"
      v-on:event-gerar-pdf="gerarPDF(modalImpressao.conteudo)"
      v-on:event-gerar-nota="gerarNota(modalImpressao.conteudo)"
      v-on:event-gerar-comprovante="gerarComprovante(modalImpressao.conteudo)"
      v-on:event-gerar-cupom="imprimirCupom(modalImpressao.conteudo)"
    />

    <TipoImpressaoCustomizada v-if="$store.state.numeroEndereco == 127 || $store.state.numeroEndereco == '127'" :showModal="modalImpressao.modalAberta" :dadosDispensa="modalImpressao.conteudo" :descricaoTela="'DispensaPaciente'" v-on:close-modal="modalImpressao.modalAberta = false" />
  </v-col>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";
import DataTable from "@/components/DataTable2.vue";
import SkeletonTable from "../components/SkeletonTable";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "@/components/ModalCustomSize.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";
import TipoImpressao from "../components/TipoImpressao";
import TipoImpressaoCustomizada from "../components/TipoImpressaoCustomizada";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import Blob from "blob";
import { v4 as uuidv4 } from "uuid";

export default {
  components: {
    Alertas,
    AlertasModal,
    AlertaSnackbar,
    DataTable,
    SkeletonTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
    TipoImpressao,
    TipoImpressaoCustomizada,
  },

  data: () => ({
    //#region Paginação
    page: 1,
    search: null,
    searchItemDispensa: null,
    total: null,
    liberarFormulario: false,
    //#endregion
    subestoqueSelecionado: null,
    familiaSelecionada: null,
    itemSelecionado: null,
    liberarResponsavel: false,
    //#region Alertas
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },
    //#endregion

    rules: {
      requerido: (value) => (value != null && value != "") || "Requer o campo!",

      requeridoCampo: (value) => {
        if (
          store.state.numeroEndereco != 116 &&
          store.state.numeroEndereco != "116" &&
          store.state.numeroEndereco != 119 &&
          store.state.numeroEndereco != "119" &&
          store.state.numeroEndereco != 122 &&
          store.state.numeroEndereco != "122" &&
          store.state.numeroEndereco != 128 &&
          store.state.numeroEndereco != "128" &&
          store.state.numeroEndereco != 139 &&
          store.state.numeroEndereco != "139" &&
          store.state.numeroEndereco != 60 &&
          store.state.numeroEndereco != "60" &&
          store.state.numeroEndereco != 61 &&
          store.state.numeroEndereco != "61" &&
          store.state.numeroEndereco != 93 &&
          store.state.numeroEndereco != "93" &&
          store.state.numeroEndereco != 97 &&
          store.state.numeroEndereco != "97" &&
          store.state.numeroEndereco != 127 &&
          store.state.numeroEndereco != "127"
        ) {
          if (value != null && value != "") {
            return true;
          } else {
            return "Requer o campo!";
          }
        } else {
          return true;
        }
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
        uid: null,
      },
    },

    modalCustomSize: {
      size: "1600",
      isOpen: false,
      isEdit: false,
      isView: false,
      formTitle: "",
      buttonText: "Concluir",
      isButtonsVisible: false,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      dadosModal: {
        descricaoTela: "dispensaPaciente",
        descricaoNomeView: null,
        numeroEndereco: store.state.numeroEndereco,
        dataNascimento: null,
        descricaoCpf: "",
        descricaoCpfResponsavel: null,
        descricaoDataNascimentoResponsavel: null,
        descricaoDataNascimentoResponsavelFormatado: null,
        descricaoNome: null,
        descricaoNomeResponsavel: null,
        descricaoRG: null,
        descricaoEndereco: null,
        descricaoTelefone: null,
        indicadorCartao: null,
        numeroPaciente: null,
        descricaoRaca: null,
        indicadorTipoDispensa: null,
        numeroDispensaPaciente: null,
        dispensaPacienteSelecionado: null,
        descricaoCep: null,
        nomeMae: null,
        nomePai: null,
        numeroResidencia: null,
        base64Comprovante: null,
        baseFoto: null,
        solicitarRegistro: false,
        listaDeItensEnviados: [],
        listaDeItensExcluidos: [],

        //#region novos dados
        descricaoNomeSocial: null,
        descricaoSexo: null,
        descricaoPaisNascimento: null,
        descricaoNacionalidade: "Brasil",
        descricaoPais: null,
        descricaoEstado: null,
        descricaoMunicipio: null,
        descricaoTipoLogradouro: null,
        descricaoNumero: null,
        descricaoBairro: null,
        descricaoComplemento: null,
        descricaoCelular: null,
        descricaoEmail: null,
        descricaoCns: null,
        descricaoRg: null,
        descricaoDataExpedicao: null,
        descricaoUfOrgaoEmissor: null,
        descricaoOrgaoEmissor: null,
      },
    },

    base64Comprovante: null,
    baseFoto: null,

    modalDelete: {
      abrir: false,
      texto: "Deseja realmente devolver essa Dispensa de Paciente?",
      actualEdit: {
        dispensaPacienteSelecionado: null,
        listaDeItens: [],
      },
    },

    modalDeleteItem: {
      abrir: false,
      texto: "Deseja realmente fazer a devolução desse Produto para seu estoque?",
      actualEdit: {
        dispensaPacienteSelecionado: null,
        itemSelecionado: null,
      },
    },

    modalImpressao: {
      modalAberta: false,
      conteudo: null,
    },

    loading: false,
    tudoValido: false,
    mostrarSkeleton: true,

    //Headers para tabelas
    headers: [
      {
        text: "ID",
        value: "dispensaPaciente.numeroDispensaPaciente",
      },
      {
        text: "Nome Paciente",
        value: "paciente.descricaoNome",
      },
      {
        text: "Nome Unidade",
        value: "endereco.nomeEndereco",
      },
      {
        text: "Responsável pela Dispensa",
        value: "funcionario.nomeFuncionario",
      },
      {
        text: "Tipo Dispensa",
        value: "dispensaPaciente.indicadorTipoDispensa",
      },
      {
        text: "Data Dispensa",
        value: "dispensaPaciente.dataDispensa",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItensDispensados: [
      {
        text: "ID",
        value: "itemDispensa.numeroItemDispensaPaciente",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Qt. Atual",
        value: "itemUnidade.quantidadeEstoque",
      },
      {
        text: "Quantidade Dispensada",
        value: "itemDispensa.quantidadeDispensada",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "value",
      },
      {
        text: "Lote",
        value: "lote",
      },
      {
        text: "Nome Produto",
        value: "nomeItem",
      },
      {
        text: "Validade",
        value: "validade",
      },
      {
        text: "Qt. Total",
        value: "quantidadeAtual",
      },
      {
        text: "Qt. que deseja remover do Estoque (Digite Abaixo)",
        value: "quantidade",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    panelDispensa: [0, 1, 2],
    panelDadosPaciente: [0, 1, 2, 3, 4],

    //Array populado pela função inicializar
    lista: [],
    dispensasDoPaciente: [],
    listaDePacientes: [],
    listaDeSubestoque: [],
    listaDeMateriais: [],
    listaDeKits: [],
    listaDeItensKit: [],
    listaDeFamilias: [
      {
        value: 1,
        text: "Medicações",
      },
      {
        value: 2,
        text: "Materiais",
      },
      {
        value: 3,
        text: "Psicotrópicos",
      },
      {
        value: 4,
        text: "Saneantes",
      },
      {
        value: 5,
        text: "Cosméticos",
      },
      {
        value: 6,
        text: "Nutrição ",
      },
      {
        value: 7,
        text: "Antimicrobianos",
      },
      {
        value: 8,
        text: "Amostra Grátis",
      },
      {
        value: 9,
        text: "Maleta de Emergência",
      },
      {
        value: 10,
        text: "Doação",
      },
      {
        value: 11,
        text: "Teste Rápido",
      },
      {
        value: 12,
        text: "USO INTERNO",
      },
    ],
    listaDeRaca: [
      { value: 1, text: "Caucasiano" },
      { value: 2, text: "Negro" },
      { value: 3, text: "Asiático" },
      { value: 4, text: "Indígena" },
      { value: 5, text: "Latino" },
      { value: 6, text: "Árabe" },
      { value: 7, text: "Mestiço" },
    ],
    listaDeSexo: [
      { value: 1, text: "Masculino" },
      { value: 2, text: "Feminino" },
      { value: 3, text: "Outro" },
    ],
    listaDePais: [
      { value: 1, text: "Brasil" },
      { value: 2, text: "Outros" },
    ],
    listaDeEstado: [
      { value: 1, text: "São Paulo" },
      { value: 2, text: "Outros" },
    ],
    listaDeMunicipio: [
      { value: 1, text: "Itu" },
      { value: 2, text: "Outros" },
    ],
    listaDeTipoLogradouro: [
      { value: 1, text: "Rua" },
      { value: 2, text: "Avenida" },
      { value: 3, text: "Travessa" },
      { value: 4, text: "Praça" },
      { value: 5, text: "Alameda" },
      { value: 6, text: "Estrada" },
      { value: 7, text: "Largo" },
      { value: 8, text: "Viela" },
      { value: 9, text: "Rodovia" },
    ],
  }),

  created() {
    this.mostrarSkeleton = true;
    this.gerarNovoToken();
  },

  watch: {
    tudoValido() {
      this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
    },

    async "modalCustomSize.dadosModal.descricaoCpf"() {
      if (this.modalCustomSize.dadosModal.descricaoCpf.length == 14) {
        this.loading = true;
        await this.buscarPessoa();
        this.loading = false;
      } else {
        this.modalCustomSize.dadosModal.descricaoNome = null;
        this.modalCustomSize.dadosModal.dataNascimento = null;
        this.modalCustomSize.dadosModal.numeroPaciente = null;
        this.liberarFormulario = false;
      }
    },

    async "modalCustomSize.dadosModal.dataNascimento"() {
      if (this.modalCustomSize.dadosModal.dataNascimento != null) {
        if (this.modalCustomSize.dadosModal.dataNascimento.length == 10) {
          if (this.validaIdadeMenor(this.modalCustomSize.dadosModal.dataNascimento)) {
            this.liberarResponsavel = true;
          } else {
            this.liberarResponsavel = false;
          }
        }
      }
    },

    "modalCustomSize.dadosModal.descricaoDataNascimentoResponsavelFormatado"() {
      if (this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavelFormatado != null) {
        if (this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavelFormatado.length == 10) {
          this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavel = this.formataDataBanco(this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavelFormatado);
        }
      }
    },

    itemSelecionado() {
      if (this.itemSelecionado) {
        const verificarItem = this.modalCustomSize.dadosModal.listaDeItensEnviados.filter((item) => item.value == this.itemSelecionado);

        if (verificarItem.length <= 0) {
          const itemInsert = this.listaDeMateriais.filter((item) => item.value == this.itemSelecionado);

          this.modalCustomSize.dadosModal.listaDeItensEnviados.unshift(itemInsert[0]);
          this.itemSelecionado = "";
        } else {
          this.alertaModal.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "Esse produto já se encontra na lista. Se necessario adicionar mais, altere o valor no produto já selecionado.";
          this.alertaSnackbar.mostrar = true;
        }
      }
    },

    async subestoqueSelecionado() {
      this.familiaSelecionada = null;
      await this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionado, this.familiaSelecionada);
    },

    async familiaSelecionada() {
      await this.listarItensDisponiveisNaUnidade(this.subestoqueSelecionado, this.familiaSelecionada);
    },
  },

  methods: {
    //#region LISTAGENS
    async inicializar() {
      try {
        await this.listarDispensas();
        await this.listarSubEstoques();
        await this.listarItensDisponiveisNaUnidade();
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.mostrarSkeleton = false;
      }
    },

    async listarDispensas() {
      try {
        const dispensas = await axios.put("dispensaPaciente", { numeroEndereco: store.state.numeroEndereco, page: this.page, search: this.search }, this.config);
        if (!dispensas.data || dispensas.data.length > 0) {
          this.lista = dispensas.data;
          this.total = dispensas.data[0].dispensaPaciente.total;
        } else {
          this.lista = [];
        }

        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.showSkeletonTable = false;
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if (search) {
        this.search = search;
        this.page = 1;
        await this.listarDispensas();
      } else {
        this.page = 1;
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page;
      await this.listarDispensas();
    },

    async listarSubEstoques() {
      try {
        let responseSubestoque = await axios.put("subestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);

        this.listaDeSubestoque = responseSubestoque.data.map((row) => {
          return {
            value: row.numeroSubestoque,
            text: row.nomeSubestoque,
          };
        });

        if (this.listaDeSubestoque.length > 0) {
          this.showSubestoquesField = true;
        } else {
          this.showSubestoquesField = false;
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarItensDisponiveisNaUnidade(numeroSubestoque, indicadorStatusFamilia) {
      try {
        this.alertaModal.tipo = "";
        const responseItens = await axios.put(
          "itemEstoqueUnidade",
          {
            numeroEndereco: store.state.numeroEndereco,
            numeroSubEstoque: numeroSubestoque,
            indicadorStatusFamilia: indicadorStatusFamilia,
            semVazios: true,
          },
          this.config
        );

        this.listaDeMateriais = responseItens.data.map((row) => {
          return {
            value: row.item.numeroItem,
            text: "Validade: " + row.item.validade + " " + row.nomeItemPadrao + " Lote: " + row.item.lote,
            nomeItem: row.nomeItemPadrao,
            lote: row.item.lote,
            validade: row.item.validade,
            quantidadeAtual: row.itemUnidade.quantidadeEstoque,
            numeroItemUnidade: row.itemUnidade.numeroItemUnidade,
          };
        });
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async listarItensDispensa(dispensaSelecionada) {
      try {
        const response = await axios.put("itensDispensadosPaciente", { numeroDispensaPaciente: dispensaSelecionada.dispensaPaciente.numeroDispensaPaciente }, this.config);
        this.modalCustomSize.dadosModal.listaDeItensEnviados = response.data;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    async buscarPessoa() {
      try {
        this.alertaModal.texto = null;
        this.alertaModal.tipo = null;
        this.alertaSnackbar.mostrar = false;

        const pessoa = await axios.put("/buscarpessoa", { numeroCpf: this.modalCustomSize.dadosModal.descricaoCpf }, this.config);
        this.liberarFormulario = this.validarUnidade(store.state.numeroEndereco.toString());
        
        if (store.state.numeroEndereco == 139 || store.state.numeroEndereco == "139") {
          if (pessoa.data.numeroPaciente && this.validaIdade(pessoa.data.dataNascimento)) {
            this.alertaSnackbar.texto = "Paciente acima de 14 anos.";
            this.alertaSnackbar.mostrar = true;
            this.liberarFormulario = false;
          } else {
            await this.verificaLiberacaoDispensa(pessoa.data);
          }
        } else {
          await this.verificaLiberacaoDispensa(pessoa.data);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async verificaLiberacaoDispensa(pacienteSelecionado) {
      if (pacienteSelecionado.indicadorCartao == 0 && !pacienteSelecionado.primeiraDispensa) {
        this.alertaModal.texto = "Não é possível realizar a dispensa para o paciente. O paciente deverá comparecer a uma das UBS para realizar o atendimento.";
        this.alertaModal.tipo = "erro";
        this.liberarFormulario = false;
      } else if (pacienteSelecionado.indicadorCartao == 0 && pacienteSelecionado.primeiraDispensa) {
        this.alertaModal.texto = "Esta primeira dispensa está sendo liberada para o paciente. Contudo, a partir da próxima, o paciente deverá realizar o atendimento em uma das UBS.";
        this.alertaModal.tipo = "aviso";

        await this.configuraPaciente(pacienteSelecionado);
      } else {
        await this.configuraPaciente(pacienteSelecionado);
      }
    },

    async configuraPaciente(pacienteSelecionado) {
      if (!pacienteSelecionado.numeroPaciente) {
        this.modalCustomSize.dadosModal.descricaoNome = null;
        this.modalCustomSize.dadosModal.dataNascimento = null;
        this.modalCustomSize.dadosModal.numeroPaciente = null;
        this.modalCustomSize.dadosModal.descricaoRaca = null;
        this.modalCustomSize.dadosModal.nomeMae = null;
        this.modalCustomSize.dadosModal.nomePai = null;
        this.modalCustomSize.dadosModal.descricaoCep = null;
        this.modalCustomSize.dadosModal.numeroResidencia = null;
        this.modalCustomSize.dadosModal.base64Comprovante = null;
        this.modalCustomSize.dadosModal.baseFoto = null;
        this.modalCustomSize.dadosModal.descricaoEndereco = null;
        this.modalCustomSize.dadosModal.descricaoTelefone = null;

        this.modalCustomSize.dadosModal.descricaoNomeSocial = null;
        this.modalCustomSize.dadosModal.descricaoSexo = null;
        this.modalCustomSize.dadosModal.descricaoPaisNascimento = null;
        this.modalCustomSize.dadosModal.descricaoNacionalidade = "Brasil";
        this.modalCustomSize.dadosModal.descricaoPais = null;
        this.modalCustomSize.dadosModal.descricaoEstado = null;
        this.modalCustomSize.dadosModal.descricaoMunicipio = null;
        this.modalCustomSize.dadosModal.descricaoTipoLogradouro = null;
        this.modalCustomSize.dadosModal.descricaoNumero = null;
        this.modalCustomSize.dadosModal.descricaoBairro = null;
        this.modalCustomSize.dadosModal.descricaoComplemento = null;
        this.modalCustomSize.dadosModal.descricaoCelular = null;
        this.modalCustomSize.dadosModal.descricaoEmail = null;
        this.modalCustomSize.dadosModal.descricaoCns = null;
        this.modalCustomSize.dadosModal.descricaoRg = null;
        this.modalCustomSize.dadosModal.descricaoDataExpedicao = null;
        this.modalCustomSize.dadosModal.descricaoUfOrgaoEmissor = null;
        this.modalCustomSize.dadosModal.descricaoOrgaoEmissor = null;

        this.liberarResponsavel = false;
        this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavel = null;
        this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavelFormatado = null;
        this.modalCustomSize.dadosModal.descricaoCpfResponsavel = null;
        this.modalCustomSize.dadosModal.descricaoNomeResponsavel = null;

        this.dispensasDoPaciente = [];
        this.modalCustomSize.dadosModal.indicadorCartao = 0;
        this.liberarFormulario = true;
      } else {
        this.modalCustomSize.dadosModal.descricaoNome = pacienteSelecionado.descricaoNome;
        this.modalCustomSize.dadosModal.dataNascimento = this.formatarData(pacienteSelecionado.dataNascimento);
        this.modalCustomSize.dadosModal.numeroPaciente = pacienteSelecionado.numeroPaciente;
        this.modalCustomSize.dadosModal.descricaoEndereco = pacienteSelecionado.descricaoEndereco;
        this.modalCustomSize.dadosModal.descricaoTelefone = pacienteSelecionado.descricaoTelefone;

        this.liberarResponsavel = this.validaIdadeMenor(this.modalCustomSize.dadosModal.dataNascimento);
        this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavel = pacienteSelecionado.descricaoDataNascimentoResponsavel;
        this.modalCustomSize.dadosModal.descricaoDataNascimentoResponsavelFormatado = this.formataDataPadraoBrasileiro(pacienteSelecionado.descricaoDataNascimentoResponsavel);
        this.modalCustomSize.dadosModal.descricaoCpfResponsavel = pacienteSelecionado.descricaoCpfResponsavel;
        this.modalCustomSize.dadosModal.descricaoNomeResponsavel = pacienteSelecionado.descricaoNomeResponsavel;

        await this.listarDispensasDoPaciente();
        this.modalCustomSize.dadosModal.indicadorCartao = 1;
        this.liberarFormulario = true;
      }

      this.panelDadosPaciente = [0];
    },

    async listarDispensasDoPaciente() {
      try {
        this.dispensasDoPaciente = [];
        const listaDispensas = await axios.put("listarDispensasAntigas", { cpf: this.modalCustomSize.dadosModal.descricaoCpf, limite: 6 }, this.config);

        this.dispensasDoPaciente = listaDispensas.data;
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },
    //#endregion

    //#region EVENTOS REQUISIÇÃO
    async acoesModal() {
      this.modalCustomSize.isButtonsDisabled = true;
      try {
        this.loading = true;
        await this.inserir();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async inserir() {
      try {
        if (!this.liberarFormulario) {
          this.modalCustomSize.isOpen = false;
          this.inicializar();
        } else {
          if (this.modalCustomSize.dadosModal.listaDeItensEnviados.length > 0) {
            if ((store.state.numeroEndereco == 139 || store.state.numeroEndereco == "139") && this.validaIdade(this.formataDataBanco(this.modalCustomSize.dadosModal.dataNascimento))) {
              this.alertaSnackbar.texto = "Paciente acima de 14 anos não poderá receber atendimento.";
              this.alertaSnackbar.mostrar = true;
            } else {
              this.modalCustomSize.dadosModal.dataNascimento = this.formataDataBanco(this.modalCustomSize.dadosModal.dataNascimento);
              await axios.post("dispensaPaciente", this.modalCustomSize.dadosModal, this.config);
              
              this.modalCustomSize.isOpen = false;
              this.inicializar();
            }
          } else {
            this.alertaModal.texto = "Não foi possivel fazer a inserção, adicione produtos antes de fazer a Dispensa!";
            this.alertaModal.tipo = "erro";
            this.alertaSnackbar.texto = "Não foi possivel fazer a inserção, adicione produtos antes de fazer a Dispensa!";
            this.alertaSnackbar.mostrar = true;
          }
        }
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message + " Por favor atualize a pagina para recarregar o estoque!";
        this.alertaModal.tipo = "erro";
        this.modalCustomSize.isButtonsDisabled = false;
      }
    },

    async deletar() {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;
        await axios.delete("dispensaPaciente", {
          data: this.modalDelete.actualEdit,
          headers: this.config.headers,
        });

        this.alerta.texto = "Dispensa Paciente removido com sucesso!";
        this.alerta.tipo = "sucesso";
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.modalDelete.abrir = false;
        this.inicializar();
      }
    },

    async deletarItem() {
      try {
        await axios.delete("itemDispensaPaciente", {
          data: this.modalDeleteItem.actualEdit,
          headers: this.config.headers,
        });

        this.alertaModal.texto = "Produto devolvido ao estoque com sucesso!";
        this.alertaModal.tipo = "sucesso";
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        await this.listarItensDispensa(this.modalDeleteItem.actualEdit.dispensaPacienteSelecionado);
        this.modalDeleteItem.abrir = false;
      }
    },
    //#endregion

    //#region FUNÇÕES MODAL
    async modalDeInserir() {
      this.loading = true;
      try {
        await this.verificarToken();
        this.config.headers["uid"] = uuidv4();

        this.panelDispensa = [0, 1, 2];
        this.panelDadosPaciente = [];

        this.modalCustomSize.isView = false;
        this.modalCustomSize.dadosModal.descricaoNome = null;
        this.modalCustomSize.dadosModal.dataNascimento = null;
        this.modalCustomSize.dadosModal.numeroPaciente = null;
        this.modalCustomSize.dadosModal.descricaoCpf = "";
        this.modalCustomSize.dadosModal.listaDeItensEnviados = [];
        this.liberarFormulario = false;
        this.liberarFormulario = false;
        this.alertaModal.tipo = "";
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "";
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
        this.modalCustomSize.isButtonsVisible = true;
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalVisualizar(dispensaPaciente) {
      this.loading = true;
      try {
        await this.verificarToken();

        this.panelDispensa = [0, 1, 2];
        this.panelDadosPaciente = [];
        await this.listarItensDispensa(dispensaPaciente);

        this.modalCustomSize.dadosModal.numeroPaciente = dispensaPaciente.paciente.numeroPaciente;
        this.modalCustomSize.dadosModal.descricaoNomeView = dispensaPaciente.paciente.descricaoNome;
        this.modalCustomSize.dadosModal.descricaoCpf = dispensaPaciente.paciente.descricaoCpf;
        this.modalCustomSize.dadosModal.numeroDispensaPaciente = dispensaPaciente.dispensaPaciente.numeroDispensaPaciente;
        this.modalDeleteItem.actualEdit.dispensaPacienteSelecionado = dispensaPaciente;
      } catch (error) {
        console.log(error);
      } finally {
        this.modalCustomSize.formTitle = "";
        this.modalCustomSize.isEdit = false;
        this.modalCustomSize.isView = true;
        this.modalCustomSize.isButtonsDisabled = !this.tudoValido;
        this.modalCustomSize.isButtonsVisible = false;
        this.modalCustomSize.isOpen = true;
        this.loading = false;
      }
    },

    async modalDeletarItem(itemSelecionado) {
      await this.verificarToken();

      this.modalDeleteItem.actualEdit.itemSelecionado = itemSelecionado;
      this.modalDeleteItem.abrir = true;
    },

    async modalDeletar(dispensaPaciente) {
      await this.verificarToken();

      const response = await axios.put("itensDispensadosPaciente", { numeroDispensaPaciente: dispensaPaciente.dispensaPaciente.numeroDispensaPaciente }, this.config);

      this.modalDelete.actualEdit.listaDeItens = response.data;
      this.modalDelete.actualEdit.dispensaPacienteSelecionado = dispensaPaciente;
      this.modalDelete.abrir = true;
    },

    modalNotas(conteudo) {
      this.modalImpressao.conteudo = conteudo;
      this.modalImpressao.modalAberta = true;
    },
    //#endregion

    //#region FUNÇÕES NORMAIS
    fotoPaciente(image) {
      if (image) {
        var reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          console.log(reader.result);
          this.baseFoto = reader.result;
        };
        reader.onerror = function(error) {
          console.log(error);
        };
      }
    },

    fotoComprovante(image) {
      if (image) {
        var reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.base64Comprovante = reader.result;
        };
        reader.onerror = function(error) {
          console.log(error);
        };
      }
    },

    removerItemDaLista(value) {
      value.quantidade = null;
      this.modalCustomSize.dadosModal.listaDeItensExcluidos.push(this.modalCustomSize.dadosModal.listaDeItensEnviados.filter((item) => item.value == value.value));
      this.modalCustomSize.dadosModal.listaDeItensEnviados = this.modalCustomSize.dadosModal.listaDeItensEnviados.filter((item) => item.value != value.value);
    },
    //#endregion

    //#region FORMATADORES
    formataDataBanco(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        var dia2 = dia.substring(0, 2);
        return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
      } else {
        return null;
      }
    },

    formataDataPadraoBrasileiro(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      } else {
        return null;
      }
    },

    validarUnidade(unidade) {
      switch (unidade) {
        case "60":
          return true;
        case "61":
          return true;
        case "93":
          return true;
        case "97":
          return true;
        case "116":
          return true;
        case "119":
          return true;
        case "122":
          return true;
        case "128":
          return true;
        case "139":
          return true;
        case "127":
          return true;
        default:
          false;
      }
    },

    retornaDataAtual() {
      const dataAtual = new Intl.DateTimeFormat("default", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "America/Sao_Paulo",
      })
        .format(new Date())
        .replace(/,/g, "");

      var data = dataAtual.split(" ")[0];
      var dia = data.split("/")[0];
      var mes = data.split("/")[1];
      var ano = data.split("/")[2];

      return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia).slice(-2);
    },

    validaIdade(dataNascimento) {
      const dataAtual = this.retornaDataAtual();

      const dataNascimentoParts = dataNascimento.split("-");
      const anoNascimento = parseInt(dataNascimentoParts[0]);
      const mesNascimento = parseInt(dataNascimentoParts[1]);
      const diaNascimento = parseInt(dataNascimentoParts[2]);

      const dataAtualParts = dataAtual.split("-");
      const anoAtual = parseInt(dataAtualParts[0]);
      const mesAtual = parseInt(dataAtualParts[1]);
      const diaAtual = parseInt(dataAtualParts[2]);

      const diferencaAnos = anoAtual - anoNascimento;

      if (mesAtual < mesNascimento || (mesAtual === mesNascimento && diaAtual < diaNascimento)) {
        return diferencaAnos - 1 > 14;
      } else {
        return diferencaAnos > 14;
      }
    },

    validaIdadeMenor(dataNascimento) {
      const dataAtual = this.retornaDataAtual();

      const dataNascimentoParts = dataNascimento.split("/");
      const anoNascimento = parseInt(dataNascimentoParts[2]);
      const mesNascimento = parseInt(dataNascimentoParts[1]);
      const diaNascimento = parseInt(dataNascimentoParts[0]);

      const dataAtualParts = dataAtual.split("-");
      const anoAtual = parseInt(dataAtualParts[0]);
      const mesAtual = parseInt(dataAtualParts[1]);
      const diaAtual = parseInt(dataAtualParts[2]);

      const diferencaAnos = anoAtual - anoNascimento;

      if (mesAtual < mesNascimento || (mesAtual === mesNascimento && diaAtual < diaNascimento)) {
        return diferencaAnos - 1 < 17;
      } else {
        return diferencaAnos < 17;
      }
    },

    formatarData(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    filter: function(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    //#endregion

    //#region DOCUMENTOS
    async gerarPDF(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          {
            text: "Numero da Dispensa: " + conteudo.dispensaPaciente.numeroDispensaPaciente,
            style: "subheader",
          },
        ],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 48],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 32, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 8, 0, 8],
            fontSize: 16,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 12,
          // alignment: 'justify'
        },
      };

      const response = await axios.put(
        "itensDispensadosPaciente",
        {
          numeroDispensaPaciente: conteudo.dispensaPaciente.numeroDispensaPaciente,
        },
        this.config
      );
      const listaDeItens = response.data;

      if (listaDeItens.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of listaDeItens) {
          tabela[0].table.body.push([item.itemDispensa.numeroItemDispensaPaciente, item.item.lote, item.itemSistema.nomeItemSistema, item.item.validade, item.itemDispensa.quantidadeDispensada]);
        }

        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem produtos dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({
        text: "Recebi os Itens Constantes Neste Cupom",
        style: "textSignature",
      });
      docDefinition.content.push({
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 520,
            y2: 0,
            lineWidth: 1,
            style: "line",
          },
        ],
      });
      docDefinition.content.push({
        text: "Beneficiario: " + conteudo.paciente.descricaoNome,
        style: "nameText",
      });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({
          text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador,
        });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({
          text: "Bairro: " + conteudo.endereco.descricaoBairro,
        });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({
          text: "CEP: " + conteudo.endereco.descricaoCep,
        });
      }
      docDefinition.content.push({
        text: "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime,
      });

      pdfMake.createPdf(docDefinition).open();

      this.modalImpressao.modalAberta = false;
    },

    async gerarNota(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        pageOrientation: "landscape",
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          {
            text: "Numero da Dispensa: " + conteudo.dispensaPaciente.numeroDispensaPaciente,
            style: "subheader",
          },
        ],
        styles: {
          header: {
            fontSize: 42,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 32,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 28,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 96],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 56, 0, 80],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 20,
            color: "black",
          },
          tableRows: {
            fontSize: 22,
            color: "black",
          },
          subtext: {
            fontSize: 28,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 16, 0, 16],
            fontSize: 28,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 28,
          // alignment: 'justify'
        },
      };

      const response = await axios.put(
        "itensDispensadosPaciente",
        {
          numeroDispensaPaciente: conteudo.dispensaPaciente.numeroDispensaPaciente,
        },
        this.config
      );
      const listaDeItens = response.data;

      if (listaDeItens.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of listaDeItens) {
          tabela[0].table.body.push([
            { text: item.itemDispensa.numeroItemDispensaPaciente, style: "tableRows" },
            { text: item.item.lote, style: "tableRows" },
            { text: item.itemSistema.nomeItemSistema, style: "tableRows" },
            { text: item.item.validade, style: "tableRows" },
            { text: item.itemDispensa.quantidadeDispensada, style: "tableRows" },
          ]);
        }

        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem produtos dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({
        text: "Recebi os Itens Constantes Neste Cupom",
        style: "textSignature",
      });
      docDefinition.content.push({
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 760,
            y2: 0,
            lineWidth: 1,
            style: "line",
          },
        ],
      });
      docDefinition.content.push({
        text: "Beneficiario: " + conteudo.paciente.descricaoNome,
        style: "nameText",
      });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({
          text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador,
        });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({
          text: "Bairro: " + conteudo.endereco.descricaoBairro,
        });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({
          text: "CEP: " + conteudo.endereco.descricaoCep,
        });
      }
      docDefinition.content.push({
        text: "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime,
      });
      docDefinition.content.push({ text: ".", style: "bigSpace" });

      pdfMake.createPdf(docDefinition).open();

      this.modalImpressao.modalAberta = false;
    },

    async gerarComprovante(conteudo) {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      var docDefinition = {
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          {
            text: "Numero da Dispensa: " + conteudo.dispensaPaciente.numeroDispensaPaciente,
            style: "subheader",
          },
          {
            text: "-----------------------------------------------",
            style: "subheader",
          },
        ],
        styles: {
          header: {
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 14,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 14,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 48],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 32, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 8, 0, 8],
            fontSize: 14,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 12,
          // alignment: 'justify'
        },
      };

      const response = await axios.put(
        "itensDispensadosPaciente",
        {
          numeroDispensaPaciente: conteudo.dispensaPaciente.numeroDispensaPaciente,
        },
        this.config
      );
      const listaDeItens = response.data;

      if (listaDeItens.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                  { text: "", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        for (let item of listaDeItens) {
          tabela[0].table.body.push([
            "-  ",
            "Numero:" + item.itemDispensa.numeroItemDispensaPaciente + "  ",
            "Lote:" + item.item.lote + "  ",
            "Nome:" + item.itemSistema.nomeItemSistema + "  ",
            "Validade:" + item.item.validade + "  ",
            "Qtde:" + item.itemDispensa.quantidadeDispensada + "  ",
            "-----------------------------------------------",
          ]);
        }
        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem produtos dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({
        text: "-----------------------------------------------",
        style: "textSignature",
      });
      docDefinition.content.push({
        text: "Recebi os Itens Constantes Neste Cupom",
        style: "textSignature",
      });
      docDefinition.content.push({
        text: "Beneficiario: " + conteudo.paciente.descricaoNome,
        style: "nameText",
      });
      if (conteudo.endereco.descricaoEndereco) {
        docDefinition.content.push({
          text: "End.: " + conteudo.endereco.descricaoEndereco + ", " + conteudo.endereco.descricaoNumeroIdentificador,
        });
      }
      if (conteudo.endereco.descricaoBairro) {
        docDefinition.content.push({
          text: "Bairro: " + conteudo.endereco.descricaoBairro,
        });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (conteudo.endereco.descricaoCep) {
        docDefinition.content.push({
          text: "CEP: " + conteudo.endereco.descricaoCep,
        });
      }
      docDefinition.content.push({
        text: "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime,
      });

      pdfMake.createPdf(docDefinition).open();

      this.modalImpressao.modalAberta = false;
    },
    //#endregion

    //#region GERAR CUPOM
    async imprimirCupom(conteudo) {
      try {
        let dataAtual = new Date().toISOString().substr(0, 10);
        let horasAtual = new Date();
        let formattedTime = new Intl.DateTimeFormat("default", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: "America/Sao_Paulo",
        }).format(horasAtual);

        const workbook = new Workbook();

        var worksheet = workbook.addWorksheet("Comprovante Entrega", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheet.columns = [{ key: "col1", width: 50 }];

        const regex = new RegExp(".{1,35}", "g");

        let posicaoLinha = 1;
        worksheet.getCell("A" + posicaoLinha).value = "Comprovante Entrega";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 7, bold: true };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        worksheet.getCell("A" + posicaoLinha).value = "Numero da Dispensa: " + conteudo.dispensaPaciente.numeroDispensaPaciente;
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell("A" + posicaoLinha).value = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;
        worksheet.getRow(posicaoLinha).height = 4;
        posicaoLinha++;

        const response = await axios.put("itensDispensadosPaciente", { numeroDispensaPaciente: conteudo.dispensaPaciente.numeroDispensaPaciente }, this.config);
        const listaDeItensDisensa = response.data;

        if (listaDeItensDisensa.length > 0) {
          worksheet.getCell("A" + posicaoLinha).value = "PRODUTO";
          worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
          posicaoLinha++;

          listaDeItensDisensa.map((itemSelecionado) => {
            const titulo = "N. " + itemSelecionado.itemDispensa.numeroItemDispensaPaciente + " " + itemSelecionado.itemSistema.nomeItemSistema;
            const substrings = titulo.match(regex);

            substrings.forEach((substring, index) => {
              worksheet.getRow(posicaoLinha + index).height = 8;
              worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 5 };
              worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
              worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            });
            posicaoLinha += substrings.length;

            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell("A" + posicaoLinha).value = "Lote " + itemSelecionado.item.lote;
            worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
            worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
            posicaoLinha++;

            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell("A" + posicaoLinha).value = "Validade " + itemSelecionado.item.validade;
            worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
            worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
            posicaoLinha++;

            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell("A" + posicaoLinha).value = "QTDE. " + itemSelecionado.itemDispensa.quantidadeDispensada;
            worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 5 };
            worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
            posicaoLinha++;
            worksheet.getRow(posicaoLinha).height = 8;
            posicaoLinha++;
            worksheet.getRow(posicaoLinha).height = 8;
          });
          posicaoLinha++;
          worksheet.getRow(posicaoLinha).height = 8;
        } else {
          worksheet.getRow(posicaoLinha).height = 9;
          worksheet.getCell("A" + posicaoLinha).value = "Sem produtos dispensados!";
          worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
          posicaoLinha++;
          worksheet.getRow(posicaoLinha).height = 8;
          posicaoLinha++;
          worksheet.getRow(posicaoLinha).height = 8;
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell("A" + posicaoLinha).value = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        const benificiario = "Beneficiario: " + conteudo.paciente.descricaoNome;
        const substringsBenificiario = benificiario.match(regex);

        substringsBenificiario.forEach((substring, index) => {
          worksheet.getRow(posicaoLinha + index).height = 9;
          worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
          worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 6, bold: false };
          worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
        });
        posicaoLinha += substringsBenificiario.length;

        if (conteudo.endereco.descricaoEndereco) {
          const endereco = "End.: " + conteudo.endereco.descricaoEndereco;
          const substringsEndereco = endereco.match(regex);

          substringsEndereco.forEach((substring, index) => {
            worksheet.getRow(posicaoLinha + index).height = 9;
            worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 6, bold: false };
            worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
          });
          posicaoLinha += substringsEndereco.length;
        }

        if (conteudo.endereco.descricaoBairro) {
          const bairro = "Bairro: " + conteudo.endereco.descricaoBairro;
          const substringsBairro = bairro.match(regex);

          substringsBairro.forEach((substring, index) => {
            worksheet.getRow(posicaoLinha + index).height = 9;
            worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            worksheet.getCell(`A${posicaoLinha + index}`).font = { name: "Arial", family: 2, size: 6, bold: false };
            worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: "middle", horizontal: "left" };
          });
          posicaoLinha += substringsBairro.length;
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.mergeCells("A" + posicaoLinha + ":B" + posicaoLinha);
        worksheet.getCell("A" + posicaoLinha).value = "Municipio: Itu - SP";
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        if (conteudo.endereco.descricaoCep) {
          worksheet.getRow(posicaoLinha).height = 9;
          worksheet.mergeCells("A" + posicaoLinha + ":B" + posicaoLinha);
          worksheet.getCell("A" + posicaoLinha).value = "CEP: " + conteudo.endereco.descricaoCep;
          worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
          worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
          posicaoLinha++;
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.mergeCells("A" + posicaoLinha + ":B" + posicaoLinha);
        worksheet.getCell("A" + posicaoLinha).value = "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime;
        worksheet.getCell("A" + posicaoLinha).font = { name: "Arial", family: 2, size: 6, bold: false };
        worksheet.getCell("A" + posicaoLinha).alignment = { vertical: "middle", horizontal: "left" };
        posicaoLinha++;

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Comprovante Entrega.xlsx");
        });

        this.modalImpressao.modalAberta = false;
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion

    //#region VERIFICAÇÕES DE TOKENS
    async gerarNovoToken() {
      try {
        const response = await axios.post("/gerartoken", {}, this.config);

        await this.$store.dispatch("setToken", response.data.token);
        await this.$store.dispatch("setAuthenticatedState", true);

        if (response.data.token != this.config.headers["x-auth-token"]) {
          this.config.headers["x-auth-token"] = response.data.token;
        }

        this.inicializar();
      } catch (error) {
        console.log(error);
      }
    },

    async verificarToken() {
      try {
        await axios.post("/verifyToken", {}, this.config);
      } catch (error) {
        alert("Tempo de autenticação expirado, por favor realize o login novamente.");

        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    //#endregion
  },
};
</script>
